<p-confirmDialog key="main" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Instructions-->
<div class="ItemBorder">
	<h4 style="text-align: center">Instructions:</h4>

	<div class="CenterWidth">
		<ul>
			<li>
				<p>Select whether you want to add students to an existing group or create a new one</p>
			</li>
			<li>
				<p>Pick the group you want to add students to, or type in the name of your new group and select which school to add it to</p>
			</li>
			<li>
				<p>Use the first table to pick students to add</p>
			</li>
			<li>
				<p>The second table will display a list of students that will be added to the selected group</p>
			</li>
			<li>
				<p>
					Double-check the Students to Add table and press Add to Group to finish adding the students to the group (and create the group if it doesn't
					exist)
				</p>
			</li>
		</ul>
	</div>
</div>

<!--Group-->
<div class="ItemBorder TopMargin">
	<h4 style="text-align: center">Select Group</h4>

	<div class="GroupGrid">
		<label>Add to:</label>
		<div class="RadioGrid">
			<input
				type="radio"
				id="Existing"
				value="Existing"
				name="GroupOption"
				[disabled]="IsLoading() == true"
				[(ngModel)]="GroupOption"
				(ngModelChange)="onGroupOptionChange($event)"
			/>
			<label for="Existing">Existing Group</label>

			<input
				style="margin-left: 10px"
				type="radio"
				id="New"
				value="New"
				name="GroupOption"
				[disabled]="IsLoading() == true"
				[(ngModel)]="GroupOption"
				(ngModelChange)="onGroupOptionChange($event)"
			/>
			<label for="New">New Group</label>
		</div>

		<label>School:</label>
		<caass-schoolselector [ShowAll]="false" [Disabled]="IsLoading() == true"> </caass-schoolselector>

		<label *ngIf="GroupOption == 'Existing'">Group:</label>
		<p-dropdown
			*ngIf="GroupOption == 'Existing'"
			style="margin-left: 5px"
			[disabled]="IsLoading() == true"
			[options]="lstGroup"
			[(ngModel)]="SelectedGroup"
			optionLabel="GroupName"
			[filter]="true"
			filterBy="GroupName"
			[showClear]="false"
			placeholder="Select a Group"
		>
			<ng-template pTemplate="selectedItem">
				<div *ngIf="SelectedGroup">
					<div class="form-control NoBorder" style="text-align: left">
						{{ SelectedGroup.GroupName }}
					</div>
				</div>
			</ng-template>
			<ng-template let-GroupItem pTemplate="item">
				<div>
					<div class="form-control NoBorder" style="text-align: left">
						{{ GroupItem.GroupName }}
					</div>
				</div>
			</ng-template>
		</p-dropdown>

		<label *ngIf="GroupOption == 'Existing'" for="AddGroupActions">Add Optional Group Actions:</label>
		<input
			*ngIf="GroupOption == 'Existing'"
			[disabled]="IsLoading() == true"
			class="CHK"
			type="checkbox"
			id="AddGroupActions"
			[(ngModel)]="AddGroupActions"
		/>

		<label *ngIf="GroupOption == 'New'">Group Name:</label>
		<input *ngIf="GroupOption == 'New'" [disabled]="IsLoading() == true" type="text" class="form-control" [(ngModel)]="GroupName" />
	</div>
</div>

<!--Select Students-->
<div class="TopMarginExtra">
	<p-accordion>
		<p-accordionTab
			header="Select Students {{ SelectStudentExpand == true ? '(Click to Collapse)' : '(Click to Expand)' }}"
			[(selected)]="SelectStudentExpand"
		>
			<div>
				<caass-personselector
					[UpdateSchoolSelector]="false"
					[AudienceID]="1"
					[CanSwitchAudience]="false"
					[ShowAllSchools]="false"
					[MultiSelect]="true"
					[buttonMultiSelectProcessCaption]="'Add to List'"
				></caass-personselector>
			</div>
		</p-accordionTab>
	</p-accordion>
</div>

<!--Students to add table-->
<div class="TopMarginExtra">
	<p-accordion>
		<p-accordionTab
			header="Students to Add {{ StudentsToAddExpand == true ? '(Click to Collapse)' : '(Click to Expand)' }}"
			[(selected)]="StudentsToAddExpand"
		>
			<div>
				<caass-group-students-to-add
					[loading]="IsLoading() == true"
					[lstPerson]="lstPerson"
					(RemoveAll)="onRemoveAll()"
					(RemovePerson)="onRemovePerson($event)"
				>
				</caass-group-students-to-add>
			</div>
		</p-accordionTab>
	</p-accordion>
</div>

<!--Buttons-->
<div class="Buttons">
	<button [disabled]="IsLoading() == true" class="btn btn-success" (click)="onFinish()">Add to Group</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
